var formFieldErrorsDirective = function($compile) {
  return {
    require: ['ngModel'],
    restrict: 'A',
    link: function(scope, element, attrs, ctrls) {
      // Can't use a real isolate scope as it clashes with other directives that
      // require one on the same element
      let isolateScope = scope.$new();
      isolateScope.model = ctrls[0];
      isolateScope.form = ctrls[1];
      isolateScope.errors = [];

      isolateScope.model.$registerApiError = function (code) {
        code = 'api.' + code;
        isolateScope.errors.push(code);

        isolateScope.model.$setValidity(code, false);
      };

      isolateScope.model.$validators.apiValidate = function() {
        while (isolateScope.errors.length) {
          isolateScope.model.$setValidity(isolateScope.errors.shift(), true);
        }
        return true;
      };

      element.after($compile(`
        <div class="c-form__field__errors" ng-if="model.$touched || form.$submitted" ng-messages="model.$error">
          <div ng-message="email" class="c-form__field__error">Please enter a valid email address</div>
          <div ng-message="url" class="c-form__field__error">Please enter a valid URL</div>
          <div ng-message="required" class="c-form__field__error">Please enter a value</div>
          <div ng-message="passwordMatch" class="c-form__field__error">Password and confirmation do not match</div>
          <div ng-message="api.validation.mimetypes" class="c-form__field__error">Please select a valid file type</div>
          <div ng-message="pattern" class="c-form__field__error">Please enter a valid pattern</div>
        </div>
      `)(isolateScope));
    }
  };
};

formFieldErrorsDirective.$inject = ['$compile'];

export default formFieldErrorsDirective;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/directives/formFieldErrors.directive.js